import {defaultPageSize} from "~/modules/catalog/category/composables/useFacet/perPageOptions";

export const customAddProductsToWishlist = `
  mutation addProductsToWishlist($id: ID!, $items: [WishlistItemInput!]!, $pageSize: Int =  ${defaultPageSize}) {
    addProductsToWishlist(wishlistId: $id, wishlistItems: $items) {
      wishlist {
        id
        items_count
        items_v2(pageSize: $pageSize) {
          items {
            id
            product {
              uid
              __typename
              sku
            }
          }
          page_info {
            current_page
            page_size
            total_pages
          }
        }
      }
    }
  }
`;
